module.exports = __webpack_public_path__ + "img/elaterna-header_1920x60px.e81a956d.jpg";